/// <amd-module name="Dashboards/WidgetHost/MessageComponents/WidgetErrorMessage" />
import * as Resources from "Dashboards/WidgetHost/Resources";
import * as React from "react";
import { ErrorMessage } from "Reporting/Visuals/VisualMessages/ErrorMessage";
import { Size, VisualMessageAction } from "Reporting/Visuals/VisualMessages/VisualMessageBase";
import { localeFormat } from "VSS/Core/Util/String";
import { VssComponent } from "VSS/Platform/Layout";

export interface WidgetErrorMessageProps {
    widgetName: string;
    size: Size;
    onClick: () => void;
    hideTitle?: boolean;
}

/** A Widget-specific Error message for widget load failures. */
export class WidgetErrorMessage extends VssComponent<WidgetErrorMessageProps, {}> {
    public render(): JSX.Element {
        const action: VisualMessageAction = {
            ariaLabel: localeFormat(Resources.WidgetError_LinkAriaMessage, this.props.widgetName),
            text: Resources.WidgetError_LinkText,
            onClick: () => {
                this.props.onClick();
            }
        };
        return (
            <ErrorMessage
                visualTitle={this.props.widgetName}
                messageBodyText={Resources.WidgetError_BodyMessage}
                size={this.props.size}
                action={action}
                hideTitle={this.props.hideTitle}
            />
        );
    }
}
